import { Component } from "react";
import { Rocket } from "../../../assets";
import { Button } from "../../components/button";
import { Helmet } from "react-helmet-async";
class UnderConstruction extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    render() {
        return (
            <div className="not-found">
                <Helmet>
        <title>در دست ساخت | بیمه زندگی هامرز  </title>
      </Helmet>
                <div className="not-found-content">
                    <img src={Rocket} className="content-img" alt="هامرز"/>

                    <span className="content-title">
                    در حال تعمیرات فنی هستیم!
                    </span>
                    <p className="content-desc">
                    سایت در حال بروزرسانی است. تیم پشتیبانی هامرز در تلاش است تا در
                    </p>
                    <p className="content-desc">
                    سریعترین زمان ممکن سایت را آماده استفاده برای شما عزیزان نماید.
                    </p>
                    <Button onClick={() => window.location.href = "/"} myStyle="bg-blue content-btn" title="بازگشت به صفحه اصلی" />
                </div>
            </div>
        )
    }
}
export default UnderConstruction;